export const SELECTED_BOARD = "SELECTED_BOARD";
